@if (!pageTitle && isLoading) {
    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
}
<div class="d-flex flex-column ws-flex-auto min-height-0">
    @if (pageTitle) {
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs"
                         currentPageTitle="Company Property Characteristics Overrides">
        </ws-bread-crumbs>
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title page-title">{{ pageTitle }}</h4>
            </div>
        </div>
        <div class="ws-section flex-grow-1 overflow-auto bg-white py-3 px-2 ace-radius position-relative min-height-0">
            @if (isLoading) {
                <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
            } @else {
                @if (hasWritePermission) {
                    <property-characteristics-picker (descriptorsSelected)="descriptorsSelected($event)"
                                                     [descriptorsToExclude]="[]"
                                                     [disabled]="isLoading"
                                                     [entityId]="companyId"
                                                     [isForCompanyOverrides]="true"
                                                     entityName="company"
                                                     class="d-inline-block">
                    </property-characteristics-picker>
                }
                <table class="ace-table descriptor-overrides">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th>Characteristic Name</th>
                            <th>Company Usage</th>
                            <th>Site Usage</th>
                            <th>Parcel Usage</th>
                            @if (!hideComplianceFeatures) {
                                <th>Asset Usage</th>
                            }
                            <th class="text-center">Comments</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (descriptorOverride of descriptorOverrides; track descriptorOverride; let i = $index) {
                            <tr (mouseenter)="descriptorOverride.isHovered = true"
                                (mouseleave)="descriptorOverride.isHovered = false">
                                <td>
                                    <div class="cell-contents px-2">{{ descriptorOverride.categoryName }}</div>
                                </td>
                                <td>
                                    <div class="cell-contents px-2">{{ descriptorOverride.descriptorName }}</div>
                                </td>
                                <td>
                                    <div class="cell-contents px-2">
                                        @if (!isEditMode(descriptorOverride)) {
                                            <span [ngClass]="{'red': isOverridden(descriptorOverride, 'companyUsageId')}">
                                                {{ getDescriptorUsage(descriptorOverride.descriptorOverride.companyUsageId) }}
                                            </span>
                                        }
                                        @if (isEditMode(descriptorOverride)) {
                                            <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.companyUsageId"
                                                    class="form-select form-select-sm w-auto">
                                                @for (usage of usages; track usage) {
                                                    <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div class="cell-contents px-2">
                                        @if (!isEditMode(descriptorOverride)) {
                                            <span [ngClass]="{'red': isOverridden(descriptorOverride, 'siteUsageID')}">
                                                {{ getDescriptorUsage(descriptorOverride.descriptorOverride.siteUsageID) }}
                                            </span>
                                        }
                                        @if (isEditMode(descriptorOverride)) {
                                            <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.siteUsageID"
                                                    class="form-select form-select-sm w-auto">
                                                @for (usage of usages; track usage) {
                                                    <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div class="cell-contents px-2">
                                        @if (!isEditMode(descriptorOverride)) {
                                            <span [ngClass]="{'red': isOverridden(descriptorOverride, 'parcelUsageID')}">
                                                {{ getDescriptorUsage(descriptorOverride.descriptorOverride.parcelUsageID) }}
                                            </span>
                                        }
                                        @if (isEditMode(descriptorOverride)) {
                                            <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.parcelUsageID"
                                                    class="form-select form-select-sm w-auto">
                                                @for (usage of usages; track usage) {
                                                    <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                </td>
                                @if (!hideComplianceFeatures) {
                                    <td>
                                        <div class="cell-contents px-2">
                                            @if (!isEditMode(descriptorOverride)) {
                                                <span [ngClass]="{'red': isOverridden(descriptorOverride, 'assetUsageID')}">
                                                    {{ getAssetDescriptorUsage(descriptorOverride.descriptorOverride.assetUsageID) }}
                                                </span>
                                            }
                                            @if (isEditMode(descriptorOverride)) {
                                                <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.assetUsageID"
                                                        class="form-select form-select-sm w-auto">
                                                    @for (
                                                        usage of getAssetUsages(descriptorOverride.canAssetUsageBeRemoved); track usage) {
                                                        <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                                    }
                                                </select>
                                            }
                                            @if (isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]) {
                                                <i class="fa fa-spinner fa-pulse ms-2"></i>
                                            }
                                        </div>
                                    </td>
                                }
                                <td class="text-center">
                                    <div class="cell-contents px-2">
                                        @if (descriptorOverride.descriptorDTO.notes) {
                                            <i [popover]="descriptorOverride.descriptorDTO.notes"
                                               class="fa fa-commenting"
                                               triggers="mouseenter:mouseleave">
                                            </i>
                                        }
                                    </div>
                                </td>
                                <td class="text-nowrap">
                                    <div class="cell-contents row-actions crud-buttons">
                                        @if (isEditMode(descriptorOverride)) {
                                            <div>
                                                <button (click)="saveDescriptorOverride(i)"
                                                        [disabled]="serverActionSingle[i]"
                                                        class="ace-btn has-icon btn-primary"
                                                        type="button">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                                <button (click)="cancelEdit()"
                                                        [disabled]="serverActionSingle[i]"
                                                        class="ace-btn has-icon btn-primary btn-danger ms-2"
                                                        type="button">
                                                    <i class="fa fa-close"></i>
                                                </button>
                                            </div>
                                        }
                                        @if (hasWritePermission && !isEditMode(descriptorOverride)) {
                                            <div [class.invisible]="!descriptorOverride.isHovered || descriptorOverrideToEdit">
                                                <button (click)="editDescriptorOverride(descriptorOverride)"
                                                        [disabled]="serverActionSingle[i] || isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]"
                                                        class="ace-btn has-icon btn-primary"
                                                        type="button">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                <button (click)="deleteDescriptorOverride(descriptorOverride, i)"
                                                        [disabled]="!descriptorOverride.canAssetUsageBeRemoved || serverActionSingle[i] || isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]"
                                                        class="ace-btn has-icon btn-primary btn-danger ms-2"
                                                        type="button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        }
                                        @if (serverActionSingle[i]) {
                                            <i class="fa fa-spinner fa-pulse ms-2"></i>
                                        }
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    }
</div>
